import script from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=a4bafe70&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4bafe70"]])

export default __exports__